// extracted by mini-css-extract-plugin
export default {"wrap":"checklist-item_wrap__SBfQ+","editing":"checklist-item_editing__T63Sk","checked":"checklist-item_checked__Vklst","text":"checklist-item_text__L0W5b"};